// src/hooks/useDema.ts
import { useState, useEffect } from "react";
import { getCompanies } from "../api/demaService";
import { CompanyResponse } from "../types/interfaces";

const useDema = () => {
  const [companies, setCompanies] = useState<CompanyResponse[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>("");

  const fetchCompanies = async () => {
    setLoading(true);
    try {
      const data = await getCompanies();
      setCompanies(data);
      setError("");
    } catch (err: any) {
      setError(err.message || "Error fetching companies");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  return { companies, loading, error, fetchCompanies };
};

export default useDema;
